import { route, tag, type PageTour } from '../pageTour';

export const attendancePayrollTour: PageTour = {
  id: 'page-attendance-payroll',
  version: 1,
  title: 'Payroll',
  summary: 'Monthly hours and attendance totals per employee.',
  match: route('/attendance/payroll'),
  steps: [
    {
      target: tag('attendance-payroll-month'),
      title: 'Month',
      description: 'Choose the month you are preparing payroll for.',
      side: 'right',
    },
    {
      target: tag('attendance-stats'),
      title: 'Month summary',
      description: 'Working days, payable days and leave days for everyone listed below.',
      side: 'bottom',
    },
    {
      target: tag('attendance-payroll-setup'),
      title: 'Payroll setup',
      description: 'Set working days, holidays and which kinds of day count as payable.',
      side: 'bottom',
    },
    {
      target: tag('attendance-payroll-csv'),
      title: 'Download CSV',
      description: 'Export the rows shown below as a spreadsheet for your payroll team.',
      side: 'bottom',
    },
    {
      target: tag('attendance-payroll-formula'),
      title: 'How payable is worked out',
      description: 'The formula behind the Payable column. Open "What do these columns mean?" for the details.',
      side: 'bottom',
    },
    {
      target: tag('attendance-table'),
      title: 'Payroll sheet',
      description: 'Days seen by the cameras for each employee, plus leave you can type in yourself.',
      side: 'top',
    },
  ],
};
